// File: Stripe.js
import React, { useState } from "react";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getStripeSku } from "../../const/Pay";
import CustomCardPaymentForm from "./CustomCardPaymentForm";

// 确保在组件渲染之外调用 loadStripe
const stripePromise = loadStripe(getStripeSku());

const Stripe = ({weightLossFormData, paymentType, price, logEvent = () => {}, ...props}) => {
    return (
        <Elements stripe={stripePromise}>
            <CustomCardPaymentForm 
                weightLossFormData={weightLossFormData}
                paymentType={paymentType} 
                price={price} 
                logEvent={logEvent} 
                {...props} 
            />
        </Elements>
    );
}

export default Stripe;